import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, ComponentFactoryResolver, Input, OnDestroy } from '@angular/core';
import { Dropdown } from '@eds/vanilla/dropdown/Dropdown';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import * as _ from 'lodash';
import { saveAs } from 'file-saver';
import {VerticalBarChartStacked} from '@eds/vanilla/charts/bar-charts/VerticalBarChartStacked'
import { deviceUsageDataService } from '../service/deviceUsage.data.service';
import {Donut} from '@eds/vanilla/charts/donut/Donut';
import {LineChart} from '@eds/vanilla/charts/line-chart/LineChart';
import * as languageConfig from '../../../../../src/assets/i18n/configuration/configuration.json';
import { TranslateService } from '@ngx-translate/core';

declare var jQuery: any;
@Component({
  selector: 'app-data-devices-component',
  templateUrl: './data-devices-component.component.html',
  styleUrls: ['./data-devices-component.component.css'],
})
export class DataDevicesComponentComponent implements OnInit, OnDestroy {

  @Input() dataFiltered: string;
  @ViewChild('tabletoverviewdrop', {static: false})
  private tabletoverviewMenu: ElementRef;

  @ViewChild('laptopoverviewdrop', {static: false})
  private laptopoverviewMenu: ElementRef;

  @ViewChild('usertodevicedrop', {static: false})
  private usertodeviceMenu: ElementRef;

  @ViewChild('tabletusagedrop', {static: false})
  private tabletusageMenu: ElementRef;

  @ViewChild('laptopusagedrop', {static: false})
  private laptopusageMenu: ElementRef;

  @ViewChild('deviceinventorydrop', {static: false})
  private deviceinventoryMenu: ElementRef;

  deviceOverview = [];
  tabletUtilization = [];
  tabletUtilizationSetting = {
    selector: 'tabletUtilChart',
    width: 200,
    height: 200,
    hole: 90,
    colors : ['#0c9b5b', '#4e4e4e'],
    total: 'percentage',
    totalText: 'Utilization'
  };
  isNaN: Function = Number.isNaN;
  stackedChartData1:any;
  stackedChartData2:any;
  lineChartData1:any;


  tabletConnectivity = [];
  tabletConnectivitySetting = {
    selector: 'tabletConnectChart',
    width: 200,
    height: 200,
    hole: 90,
    colors : ['#0c9b5b', '#4e4e4e'],
    total: 'percentage',
    totalText: 'Connectivity'
  };
  fontBig = '64px';
  fontSmall = '44px';
  laptopUtilization = [];
  laptopUtilizationSetting = {
    selector: 'laptopUtilChart',
    width: 200,
    height: 200,
    hole: 90,
    colors : ['#a56ebe', '#4e4e4e'],
    total: 'percentage',
    totalText: 'Utilization'
  };
  laptopConnectivity = [];
  laptopConnectivitySetting = {
    selector: 'laptopConnectChart',
    width: 200,
    height: 200,
    hole: 90,
    colors : ['#a56ebe', '#4e4e4e'],
    total: 'percentage',
    totalText: 'Connectivity'
  };

  deviceUsageData: any;
  sumofDevicesItems: any = [];
  datas_01_01 = {
    students: 150,
    teachers: 40,
    admins: 10
  };

  edsDeviceChart1 :any;
  edsDeviceChart2 :any;
  edsDeviceChart3 :any;
  edsDeviceChart4 :any;
 
  isDonutloaded1=false;
  isDonutloaded2=false;
  isDonutloaded3=false;
  isDonutloaded4=false;
  userPerDevice = 0;
  usertoDeviceTrendChartData = [];


vertBarChartloaded1=false;
vertBarChartloaded2=false;
linechartLoaded = false;

  math = Math;

  tabletDailyUseData = [];
  tabletDailyUseKeys = [];
  laptopDailyUseData = [];
  laptopDailyUseKeys = [];


  deviceUsage: any;

  inventoryReport: any = [];

  subscription = [];

  userData: any;
textDir:any;
  constructor(private deviceUsageService: deviceUsageDataService, private routeParams: ActivatedRoute, private translate:TranslateService){

    this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    this.loadAllSectionsData();
  }

  ngOnDestroy() {
    this.subscription.forEach(sub => {
      sub.unsubscribe();
    });
  
  }
  ngDoCheck() {

   
     if (document.getElementById('stacked-chart1')){
      if (!this.vertBarChartloaded1 && document.getElementById('stacked-chart1').clientHeight > 0){
        document.getElementById('stacked-chart1').innerHTML = '';
        //console.log("devices tab")
        this.vertStackedBarchartInit1();
        this.vertBarChartloaded1 = true;
      }
    }
    if (document.getElementById('stacked-chart2')){
      if (!this.vertBarChartloaded2 && document.getElementById('stacked-chart2').clientHeight > 0){
        document.getElementById('stacked-chart2').innerHTML = '';
        this.vertStackedBarchartInit2();
        this.vertBarChartloaded2 = true;
      }
    }
   if (document.getElementById('device-linechart')){
      if (!this.linechartLoaded && document.getElementById('device-linechart').clientHeight > 0){
        document.getElementById('device-linechart').innerHTML = '';
        if(this.lineChartData1){
          this.linechartInit1();
          setTimeout(function(){​​​​ 
            jQuery('#device-linechart').find('rect').attr('pointer-events','none');
          }​​​​, 1000);
        }
       
        this.linechartLoaded = true;
      }
    } 
   
  }
    ngAfterViewInit() {
      let params: any = this.routeParams.snapshot.params;
      this.userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
      const tabletoverviewDrop = new Dropdown(this.tabletoverviewMenu.nativeElement);
      tabletoverviewDrop.init();

      const laptopoverviewDrop = new Dropdown(this.laptopoverviewMenu.nativeElement);
      laptopoverviewDrop.init();

      const usertodeviceDrop = new Dropdown(this.usertodeviceMenu.nativeElement);
      usertodeviceDrop.init();

      const tabletusageDrop = new Dropdown(this.tabletusageMenu.nativeElement);
      tabletusageDrop.init();

      const laptopusageDrop = new Dropdown(this.laptopusageMenu.nativeElement);
      laptopusageDrop.init();

      const deviceinventoryDrop = new Dropdown(this.deviceinventoryMenu.nativeElement);
      deviceinventoryDrop.init();
    }
vertStackedBarchartInit1(){
  document.getElementById('stacked-chart1').innerHTML="";
  const chart01 = new VerticalBarChartStacked({
    element: document.getElementById('stacked-chart1'),
    data: this.stackedChartData1,
    y: { unit: 'Minutes' }
  });
  
  chart01.init();
}
vertStackedBarchartInit2(){
  document.getElementById('stacked-chart2').innerHTML="";
  const chart02 = new VerticalBarChartStacked({
    element: document.getElementById('stacked-chart2'),
    data: this.stackedChartData2,
    y: { unit: 'Minutes' }
  });
  
  chart02.init();
}


donutChartInit1(){
  document.getElementById('percentagedonut1').innerHTML="";
  const chart1 = new Donut({
    element: document.getElementById('percentagedonut1'),
    data: this.edsDeviceChart1,     
    showValue: true,
    
    unit: 'Utilisation'
  });
  chart1.init();
 
}
donutChartInit2(){
  document.getElementById('percentagedonut2').innerHTML="";
  const chart2 = new Donut({
    element: document.getElementById('percentagedonut2'),
    data: this.edsDeviceChart2,
    showValue: true,
    unit: 'Connectivity'
  }); 
  chart2.init();
     
}
donutChartInit3(){
  document.getElementById('percentagedonut3').innerHTML="";
  const chart3 = new Donut({
    element: document.getElementById('percentagedonut3'),
    data: this.edsDeviceChart3,
    showValue: true,
    unit: 'Utilisation'
  });

 chart3.init();
}
donutChartInit4(){
  document.getElementById('percentagedonut4').innerHTML="";
  const chart4 = new Donut({
    element: document.getElementById('percentagedonut4'),
    data: this.edsDeviceChart4,
   
    showValue:true,
    unit: 'Connectivity'
  });
  
  chart4.init();
}

linechartInit1(){

  document.getElementById('device-linechart').innerHTML="";
  const linechart = new LineChart({
    element: document.getElementById('device-linechart'),
    data: this.lineChartData1,
    height: 250,
    margin: {
      left: 45,
    },
    y: {
      unit: 'Visits',
    },
    tooltip: {
      format: {
        title: '%d %B',
        value: 'd',
      }
    }
  });
  
  linechart.init();
  
}

    loadAllSectionsData() {

      // device
      const sub = this.deviceUsageService.deviceUsage$Data.subscribe(data => {
        // all load data service
        this.deviceUsageService.getDeviceOverviewData();
        // this.deviceUsageService.getTabletOverviewData();
        this.deviceUsageService.getTabletOverviewUtilizationData();
        this.deviceUsageService.getTabletOverviewConnectivityData();
        // this.deviceUsageService.getLaptopOverviewData();
        this.deviceUsageService.getLaptopOverviewUtilizationData();
        this.deviceUsageService.getLaptopOverviewConnectivityData();

        this.deviceUsageService.getUserToDeviceAvgData();
        this.deviceUsageService.getUserToDeviceTrendData();

        this.deviceUsageService.getTabletDailyUseData();
        this.deviceUsageService.getLaptopDailyUseData();

        // this.deviceUsageService.getDeviceInventoryData();

        this.getTabletOverview();
        this.getLaptopOverview();
        this.getDeviceOverview();
        this.getUserToDevice();
        this.getTabletDailyUsage();
        this.getLaptopDailyUsage();
        this.getDeviceInventory();
      });
      this.subscription.push(sub);
    }

    getDeviceOverview() {
      // this.userUsageService.getUserActivityOverviewData();
      const sub = this.deviceUsageService.deviceOverview$Data.subscribe(data => {
        this.deviceOverview = [...data];
        //console.log("deiceOverview >>> "+JSON.stringify(this.deviceOverview));
      });
      this.subscription.push(sub);
    }

    getTabletOverview() {
      // this.userUsageService.getUserActivityOverviewData();
      const sub2 = this.deviceUsageService.tabletUtilization$Data.subscribe(data => {
        this.tabletUtilization = [...data];
        const edsDataObj = [];
        const noedsDataObj= [];
        console.log('tabletUtilization>>> ' + JSON.stringify(this.tabletConnectivity));
        this.tabletUtilization.forEach((a,index) => {
          const dataObj = {name: a.id, values: [a.count], colorID: (index+1).toString()};
          edsDataObj.push(dataObj);
        });
        const nodataObj =[{name:"Deployed",values:[200],colorID:"1"},{name:"Used",values:[120],colorID:"2"}];        
        
        if(this.tabletUtilization.length>0){
          this.edsDeviceChart1 = {"series": edsDataObj};
        }else{

          this.edsDeviceChart1 = {"series": nodataObj};
        }
        this.donutChartInit1();
      });
      this.subscription.push(sub2);
      const sub3 = this.deviceUsageService.tabletConnectivity$Data.subscribe(data => {
       
        this.tabletConnectivity = [...data];
        const edsDataObj1 = [];
        const noedsDataObj1 = [];
        console.log('tabletConnectivity >>> ' + JSON.stringify(data));
        this.tabletConnectivity.forEach((a,index) => {
          const dataObj1 = {name: a.id, values: [a.count], colorID: (index+1).toString()};
          edsDataObj1.push(dataObj1);
        });
        const nodataObj1 = [{name:"Deployed",values:[200],colorID:"1"},{name:"Used",values:[120],colorID:"2"}]

        noedsDataObj1.push(nodataObj1);
        if(this.tabletConnectivity.length>0){
          this.edsDeviceChart2 = {series: edsDataObj1};
        }else{
          this.edsDeviceChart2 = {series: nodataObj1};
        }
        this.donutChartInit2();
      });
      this.subscription.push(sub3);
    }

    getLaptopOverview() {
      const sub2 = this.deviceUsageService.laptopUtilization$Data.subscribe(data => {
        ////console.log('user activity overview Per>>> ' + JSON.stringify(data));
        this.laptopUtilization = [...data];
        const edsDataObj2 = [];
        const noedsDataObj2 =[];
        console.log('user laptopUtilization>>> ' + JSON.stringify(this.laptopUtilization));

        this.laptopUtilization.forEach((a,index) => {
          const dataObj2 = {name: a.id, values: [a.count], colorID: (index+1).toString()};
          edsDataObj2.push(dataObj2);
        });
        // edsDataObj.push({name: 'test', value: ['300'], colorID: '3'});
        this.edsDeviceChart3 = {series: edsDataObj2};
        const nodataObj3 =[{name:"Deployed",values:[200],colorID:"1"},{name:"Used",values:[120],colorID:"2"}]
        noedsDataObj2.push(nodataObj3);
        if(this.laptopUtilization.length>0){
          this.edsDeviceChart3 = {"series": edsDataObj2};

        }else{

          this.edsDeviceChart3 = {"series": nodataObj3};
        }
        this.donutChartInit3();
      });
      this.subscription.push(sub2);


      const sub3 = this.deviceUsageService.laptopConnectivity$Data.subscribe(data => {
      
        this.laptopConnectivity = [...data];
        console.log('laptopConnectivity >>> ' + JSON.stringify(data));
        const edsDataObj3 = [];
        const noedsDataObj3=[];
        this.laptopConnectivity.forEach((a,index) => {
          const dataObj3 = {name: a.id, values: [a.count], colorID: (index+1).toString()};
          edsDataObj3.push(dataObj3);
        });
       
        const nodataObj4 = [{name:"Deployed",values:[200],colorID:"1"},{name:"Used",values:[120],colorID:"2"}]
        noedsDataObj3.push(nodataObj4);
        if(this.laptopConnectivity.length>0){
          this.edsDeviceChart4 = {"series": edsDataObj3};

        }else{

          this.edsDeviceChart4 = {"series": nodataObj4};
        }
        this.donutChartInit4();
      });

      this.subscription.push(sub3);
    }

    getUserToDevice() {
      // this.userUsageService.getUserActivityOverviewData();
      const sub1 = this.deviceUsageService.userPerDevice$Data.subscribe(data => {
        ////console.log('user activity overview >>> ' + JSON.stringify(data));
        this.userPerDevice = data;
       
        
      });
      this.subscription.push(sub1);
      const sub2 = this.deviceUsageService.userPerDeviceDaily$Data.subscribe(data => {
       ////console.log('user to device trend >>> ' + JSON.stringify(data));
        this.usertoDeviceTrendChartData = [...data];
        const commonArr = [];
        const valuesArr = [];
        let seriesdata:any;
         // let edsLineDataObj1 = [{"count":"80","date":"2019-11-11T18:30:00.000Z"},{"count":"80","date":"2019-11-12T18:30:00.000Z"}]
        let idArr = [];
        this.usertoDeviceTrendChartData.forEach((a, index ) => {
          idArr.push(a.id);
          // KAJAL
          for ( const items of a.values ){
            valuesArr.push(items.count);
            commonArr.push(items.date);
          }
          seriesdata = {
            series: [{name: idArr[index], values: valuesArr}],
            common: commonArr
          }
        });
       //console.log('getUserToDevice >>> ' + JSON.stringify(seriesdata));
      //  this.lineChartData1 = seriesdata;


        
      
      let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
      let series = [{name:"Ethernet/Wi-fi/SIM",values:["0","10","20","30","40"]},{name:"No Connection", values:["0","10","20","30","40"]}]
      let noseriesdata = {
        series: series,
        common: commonArr
      }
      
      if(this.usertoDeviceTrendChartData.length>0){
        this.lineChartData1 = seriesdata;
       /*  setTimeout(function(){​​​​ 
          jQuery('#device-linechart').find('rect').attr('pointer-events','all');
        }​​​​, 1000); */
      }else{
        this.lineChartData1 = noseriesdata;
       /*  setTimeout(function(){​​​​ 
          jQuery('#device-linechart').find('rect').attr('pointer-events','none');
        }​​​​, 1000); */
        //getrect[0].style.backgroundColor = "red";
        
        


      }
  
      if(this.lineChartData1){
        this.linechartInit1();
        //added by janaki 
      
      }
  
  
       
      });
      this.subscription.push(sub2);
    }

getusertoDevicetrend(){
  const sub1 = this.deviceUsageService.userPerDevice$Data.subscribe(data => {
    ////console.log('user activity overview >>> ' + JSON.stringify(data));
    this.userPerDevice = data;
   
    
  });

  let sArr=[];
    let cArr=[];
    const sub =  this.deviceUsageService.userPerDeviceDaily$Data.subscribe(data => {
    this.usertoDeviceTrendChartData = [...data];
   //console.log('usertoDeviceTrendChartData >>> ' + JSON.stringify(this.usertoDeviceTrendChartData));
    const commonArr = [];
    let valuesArr = [];
    
    let idArr = [];   
    this.usertoDeviceTrendChartData.forEach((item,index) => {   
      let i = 0;
      idArr.push(item.id);
     for (const items of item.values) {      
        i++;
        valuesArr.push(items.count);
        commonArr.push(items.date);      
      }   
      sArr = valuesArr;
      cArr = commonArr;
    });
   
    const seriesArr = [{"name": idArr, "values": valuesArr}]  
   
   
    let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
    let series = [{name:"Ethernet/Wi-fi/SIM",values:["0","10","20","30","40"]},{name:"No Connection", values:["0","10","20","30","40"]}]
    
    
    if(this.usertoDeviceTrendChartData.length>0){
      this.lineChartData1 = {series: seriesArr, common:commonArr};
    }else{
      this.lineChartData1 = {series: series, common:common};
    }
   //console.log("lineChartData >>> "+JSON.stringify(this.lineChartData1));
   this.linechartInit1();
    });
    this.subscription.push(sub);
}
    getTabletDailyUsage() {
      const sub = this.deviceUsageService.tabletDaily$Data.subscribe(data => {
       
        this.tabletDailyUseData = [...data];
       // console.log('tablet daily use length >>> ' + JSON.stringify(this.tabletDailyUseData.length));
        if (this.tabletDailyUseData && this.tabletDailyUseData[0]) {
          this.tabletDailyUseKeys = Object.keys(this.tabletDailyUseData[0]);
        }
         const commonArr = [];
        const idArr = ["Ethernet/Wi-fi/SIM", "No Connection"];
        let valuesArr1 = [];
        let valuesArr2 = [];
        this.tabletDailyUseData.forEach((a, index ) => {
          idArr.push(a.date);
          // KAJAL          
          if(a.key == "No Connection"){
            commonArr.push(a.value);
          }
          for (var key in a) { 
            if (a.hasOwnProperty(key)) { 
              
              if(key == "Ethernet/Wi-fi/SIM" ){
                valuesArr1.push(a[key]);
                
              }
              if(key == "No Connection" ){
                valuesArr2.push(a[key]);
                
              }
              if(key == "date" ){
               let datestr = a[key];
              ////console.log("Date>>>> "+a[key]+" >>>>> "+datestr.toLocaleDateString())
                commonArr.push(datestr.toLocaleDateString('fr-CA'));
                
              }
                
            } 
        }  
         
        });
     let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
     let nostackedData = {
      "common": common,
      "series": [{"name":"Ethernet/Wi-fi/SIM","values":["0","20","40","60","80"]},{"name":"No Connection","values":["0","20","40","60","80"]}]
    };
     
        let stackedData = {
          "common": commonArr,
          "series": [{"name":"Ethernet/Wi-fi/SIM","values":valuesArr1},{"name":"No Connection","values":valuesArr2}]
        };
        
       

    if(this.tabletDailyUseData.length>0){
       //console.log('tabletDailyUseData >>> ' + JSON.stringify(stackedData));
        this.stackedChartData1 = stackedData;
       
      }else{
       //console.log('tabletDailyUseData else no data >>> ' + JSON.stringify(nostackedData));
        this.stackedChartData1 = nostackedData;
      }
      this.vertStackedBarchartInit1();
     
      });
      
     
      this.subscription.push(sub);
    }
    
    getLaptopDailyUsage() {
      const sub = this.deviceUsageService.laptopDaily$Data.subscribe(data => {
         //console.log('laptop daily use >>> ' + JSON.stringify(data.length));
        this.laptopDailyUseData = [...data];
        if (this.laptopDailyUseData && this.laptopDailyUseData[0]) {
          this.laptopDailyUseKeys = Object.keys(this.laptopDailyUseData[0]);
        }
        const commonArr = [];
        const idArr = ["Ethernet/Wi-fi/SIM", "No Connection"];
        let valuesArr1 = [];
        let valuesArr2 = [];
        this.laptopDailyUseData.forEach((a, index ) => {
          idArr.push(a.date);
          // KAJAL
          
          if(a.key == "No Connection"){
            commonArr.push(a.value);
          }
          for (var key in a) { 
            if (a.hasOwnProperty(key)) { 
              
              if(key == "Ethernet/Wi-fi/SIM" ){
                valuesArr1.push(a[key]);
                
              }
              if(key == "No Connection" ){
                valuesArr2.push(a[key]);
                
              }
              if(key == "date" ){
                let datestr = a[key];
               ////console.log("Date>>>> "+a[key]+" >>>>> "+datestr.toLocaleDateString())
                commonArr.push(a[key].toLocaleDateString('fr-CA'));
                
              }
                
            } 
        }  
         
        });
        let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
       
        let stackedData;     
        let nostackedData;
        if(this.laptopDailyUseData.length == 0){
         ////console.log("laptopDaily Use no data >> ")
          let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
          let series = [{name:"Ethernet/Wi-fi/SIM",values:["0","20","40","60","80"]},{name:"No Connection", values:["0","20","40","60","80"]}]
          
          nostackedData = {
            "common": common,
            "series": series
          }  
          this.stackedChartData2 = nostackedData;
        }else{
         ////console.log("laptopDaily Use with data >> ")
          let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
          
          stackedData = {
            "common": commonArr,
            "series": [{name:"Ethernet/Wi-fi/SIM",values:valuesArr1},{name:"No Connection",values:valuesArr2}]
          }  
          this.stackedChartData2 = stackedData;
        }
        this.vertStackedBarchartInit2();
      });
     
    
      this.subscription.push(sub);
    }

    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
           const key = keyGetter(item);
           const collection = map.get(key);
           if (!collection) {
               map.set(key, [item]);
           } else {
               collection.push(item);
           }
      });
      return map;
  }

  groupObj(array, key){
    var result=_.chain(array).groupBy(key).map(function(v, i) {
      return {
        name: i,  
        date: _.map(v, 'date'), 
        values: _.map(v, 'Ethernet/Wi-fi/SIM')

      }
    }).value();
    return result;
   }

    getDeviceInventory() {
      const sub = this.deviceUsageService.deviceInventory$Data.subscribe(data => {
        this.inventoryReport = [...data];
        //console.log("Device Inventory >>>> "+JSON.stringify(this.inventoryReport))
        if(this.inventoryReport.length == 0){
          this.inventoryReport = [{"osName":"Fedora","manufacturerName":"Samsung","modeNo":"Sam_125G679","qty":0},{"osName":"Ubuntu","manufacturerName":"Hp","modeNo":"HP_Pro","qty":0},{"osName":"Windows","manufacturerName":"Samsung","modeNo":"Sam_userwidows12","qty":0},{"osName":"Windows","manufacturerName":"Dell","modeNo":"Dell60","qty":0},{"osName":"Android","manufacturerName":"Nokia","modeNo":"Nokia123","qty":0},{"osName":"Linux","manufacturerName":"Dell","modeNo":"Dell34Linux","qty":0},{"osName":"Android","manufacturerName":"Samsung","modeNo":"SamAndroid","qty":0},{"osName":"Android","manufacturerName":"Samsung","modeNo":"wer1234","qty":0},{"osName":"Windows","manufacturerName":"HP","modeNo":"HP_Pro","qty":0}]
        }
      });
      this.subscription.push(sub);
    }

  generateCSV(section: any) {
    if (section === 'devices-tablet') {
      const csv = this._objectArrayToCsv(this.deviceOverview);
      this._downloadFile(section, csv);
    }
    if (section === 'devices-laptop') {
      const csv = this._objectArrayToCsv(this.deviceOverview);
      this._downloadFile(section, csv);
    }
    if (section === 'user-to-device') {
      let csv = new Array();
      this.usertoDeviceTrendChartData.forEach(item => {
        csv.push(item.id);
        csv.push('');
        csv = csv.concat(this._objectArrayToCsv(item.values));
        csv.push('');
      });
      this._downloadFile(section, csv);
    }

    if (section === 'devices-tablet-usage') {
      const csv = this._objectArrayToCsv(this.tabletDailyUseData);
      this._downloadFile(section, csv);
    }

    if (section === 'devices-laptop-usage') {
      const csv = this._objectArrayToCsv(this.laptopDailyUseData);
      this._downloadFile(section, csv);
    }

    if (section === 'device-inventory') {
      const csv = this._objectArrayToCsv(this.inventoryReport);
      this._downloadFile(section, csv);
    }
  }

  _downloadFile(section, csv) {
    const csvArray = csv.join('\r\n');
    const blob = new Blob([csvArray], {type: 'text/csv' })
    saveAs(blob, 'overview-' + section + '.csv');
  }

  _objectArrayToCsv(data: any) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    return csv;
  }

}
